import React from 'react';
import { TextInputContainer } from '@brighte/brighte-one-native';

export default props => (
  <TextInputContainer
    customStyle={{ customStyleInput: { fontWeight: 'bold', fontSize: 23, paddingTop: 3, lineHeight: 60 } }}
    {...props}
  />
);
